export const mobilePxString = '576px';
export const tabletPxString = '768px';
export const desktopPxString = '1024px';
export const largeDesktopPxString = '1200px';

export const mobile = 576;
export const tablet = 768;
export const desktop = 1024;
export const largeDesktop = 1200;
